import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    reapplyLoanTitle: {
        id: '_.reapply_loan.title',
        defaultMessage: 'Apply for another loan'
    },
    topupLoanTitle: {
        id: '_.apply_topup_loan.title',
        defaultMessage: 'Request more funds'
    },
    requestedAmountLabel: {
        id: '_.apply_flexi_loan.requestedAmount.label',
        defaultMessage: 'How much do you need?'
    },
    topupRequestedAmountLabel: {
        id: '_.apply_flexi_loan.topupRequestedAmount.label',
        defaultMessage: 'How much more would you like to borrow?'
    },
    requestedAmountPlaceholder: {
        id: '_.apply_flexi_loan.requestedAmount.placeholder',
        defaultMessage: 'Enter an amount between {minAmount} and {maxAmount}'
    },
    loanPurposeLabel: {
        id: '_.apply_flexi_loan.loanPurpose.label',
        defaultMessage: 'What is your main reason for requesting a loan?'
    },
    topupLoanPurposeLabel: {
        id: '_.apply_flexi_loan.topupLoanPurpose.label',
        defaultMessage: 'What is your main reason for requesting more funds?'
    },
    loanPurposePlaceholder: {
        id: '_.apply_flexi_loan.loanPurpose.placeholder',
        defaultMessage: 'Please choose an option'
    },
    turnoverLabel: {
        id: '_.apply_flexi_loan.turnover.label',
        defaultMessage: 'What was your last 12 months turnover?'
    },
    turnoverPlaceholder: {
        id: '_.apply_flexi_loan.turnover.placeholder',
        defaultMessage: 'Enter turnover amount'
    },
    documentsTitle: {
        id: '_.apply_flexi_loan.documentsTitle',
        defaultMessage:
            'Thanks for applying for an additional {amount}. We need some more information from you before we can make a decision'
    },
    loanDurationLabel: {
        id: '_.apply_flexi_loan.loanDuration.label',
        defaultMessage: 'Wie lange benötigen Sie den Kredit?'
    },
    loanDurationPlaceholder: {
        id: '_.apply_flexi_loan.loanDuration.placeholder',
        defaultMessage: 'Bitte wählen Sie eine Option aus'
    },
    nextCTA: {
        id: '_.apply_flexi_loan.nextCTA',
        defaultMessage: 'Next'
    },
    submitCTA: {
        id: '_.apply_flexi_loan.submitCTA',
        defaultMessage: 'Submit application'
    },
    newCreditLimit: {
        id: '_.apply_flexi_loan.newCreditLimit',
        defaultMessage: 'Your new credit limit would be: '
    },
    unchangedCreditLimit: {
        id: '_.apply_flexi_loan.unchangedCreditLimit',
        defaultMessage: 'Your credit limit will remain: '
    },
    backButton: {
        id: '_.apply_flexi_loan.back_button',
        defaultMessage: 'Go Back'
    }
});
